// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__YJgPh","placeHolderShimmer":"Tabs_placeHolderShimmer__lGl7l"};